import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import { useDispatch, useSelector } from "react-redux";
import interactionPlugin from "@fullcalendar/interaction";
import { useEffect, useState } from "react";
import "../../../StyleSheet/MainComponent/Calender/Calender.scss";
import { setTheShiftexcelSheetRetrieveAction } from "../../../Redux/Slice";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import dayjs from "dayjs";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ConfirmationPopup from "./Confirmationpopup";
import { toast } from "react-toastify";

const localizer = momentLocalizer(moment);

const Calender = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const navigate = useNavigate();
  const [Name, setName] = useState();
  const [udsID, setUdsId] = useState();
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const sheet = state.ClientBranchIDs.ShiftExcelsheetID;

const month = Number(sheet?.month);   // "11" → 11
const year = Number(sheet?.year);     // "2025" → 2025

// 👇 create date like 2025-11-01
const initialDate = new Date(year, month - 1, 1);


const [defaultDate, setDefaultDate] = useState(initialDate);
const [currentDate, setCurrentDate] = useState(defaultDate);

    const [showPopup, setShowPopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    ////--Retrieve-----
    const payload = {
      user: state.ClientBranchIDs.ShiftExcelsheetID?.id,
    };
    dispatch(setTheShiftexcelSheetRetrieveAction(payload));
  }, []);

  const [events, setEvents] = useState([]);
console.log(state.ClientBranchIDs.ShiftExcelsheetID ,"state.ClientBranchIDs.ShiftExcelsheetID",defaultDate);

useEffect(() => {
  const shiftData = state.ShifteexcelshettRetriev?.ShfiexcelRetrieve;
  if (!shiftData) return;

  const NameCap = capitalizeFirstLetter(shiftData?.user_id?.first_name || "");
  setUdsId(shiftData?.user_id?.user_uid || "");
  setName(NameCap);
  const sheet = state.ShifteexcelshettRetriev?.ShfiexcelRetrieve
const month = Number(sheet?.month);   // "11" → 11
const year = Number(sheet?.year);     // "2025" → 2025
  console.log(month, "aspoudaopsd month");

// 👇 create date like 2025-11-01
const initialDate = new Date(year, month - 1, 1);

  if (!month || !year) return;

  // ✅ FIX: JavaScript months are 0-based
  const newDefaultDate = new Date(year, month - 1, 1);
  console.log("✅ showPopup defaultDate", newDefaultDate ,month);
  setDefaultDate(initialDate);

  const mappedEvents = [];

  for (let i = 1; i <= 31; i++) {
    const dayKey = `day_${i}`;
    const dayData = shiftData[dayKey];
    const dayString = i.toString().padStart(2, "0");
    const monthString = month.toString().padStart(2, "0");

    const startDate = `${year}-${monthString}-${dayString}T00:00:00+05:30`;
    const endDate = `${year}-${monthString}-${dayString}T23:59:59+05:30`;

    if (dayData && typeof dayData === "object") {
      mappedEvents.push({
        title: dayData.shift_name,
        start: new Date(`${year}-${monthString}-${dayString}T${dayData.from_time}+05:30`),
        end: new Date(`${year}-${monthString}-${dayString}T${dayData.end_time}+05:30`),
        type: "shift",
        day: i,
      });
    } else if (dayData === "weekoff" || dayData === "no record") {
      mappedEvents.push({
        title: dayData === "weekoff" ? "Week Off" : "No Record",
        start: new Date(startDate),
        end: new Date(endDate),
        allDay: true,
        type: dayData,
        day: i,
      });
    }
  }

  setEvents(mappedEvents);
}, [state.ShifteexcelshettRetriev?.ShfiexcelRetrieve]);


  const dayStartTime = new Date();
  dayStartTime.setHours(8, 0, 0); // Set to 8:00 AM

  const dayEndTime = new Date();
  dayEndTime.setHours(18, 0, 0); // Set to 6:00 PM

//  const handleDateClick = (slotInfo) => {
//   const clickedDate = dayjs(slotInfo.start).startOf("day");
//   const today = dayjs().startOf("day");

//   console.log("Clicked date:", clickedDate.format("YYYY-MM-DD"));

//   if (clickedDate.isBefore(today)) {
//     console.log("⛔ Past date, not allowed");
//     return;
//   }

//   setSelectedDate(clickedDate.format("YYYY-MM-DD"));
//   setShowPopup(true);
// };
const handleDateClick = (slotInfo) => {
  const clickedDate = dayjs(slotInfo.start).startOf("day");
  const today = dayjs().startOf("day");

  console.log("Clicked date:", clickedDate.format("YYYY-MM-DD"));

  // ✅ 1. Block past dates
  if (clickedDate.isBefore(today)) {
    console.log("⛔ Past date, not allowed");
    toast.error('Past date, not allowed');
    return;
  }

    const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month); 
  // backend usually gives 1–12 so we convert to 0–11

  const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);


  // ✅ 2. Allow clicks only in the current default month
  const currentMonth = dayjs(defaultDate).month(); // 0-based
const clickedMonth = clickedDate.month()+1;  // 0–11
  const clickedYear = clickedDate.year();


  // if (clickedMonth !== currentMonth) {
  //   console.log("⛔ Not in the current calendar month:", clickedDate.format("YYYY-MM-DD"));
  //   return;
  // }
  console.log(clickedMonth ,"clickedMonth", allowedMonth,slotInfo);
  
    if (clickedMonth !== allowedMonth || clickedYear !== allowedYear) {
    console.log(
      `⛔ Blocked: ${clickedDate.format("YYYY-MM-DD")} is outside allowed ${allowedMonth + 1}-${allowedYear}`
    );
    toast.error(`Blocked: ${clickedDate.format("YYYY-MM-DD")} is outside allowed ${allowedMonth}-${allowedYear}`)
    return;
  }


  // ✅ Allowed: open popup
  setSelectedDate(clickedDate.format("YYYY-MM-DD"));
  setShowPopup(true);
};


const eventPropGetter = (event) => {
  let backgroundColor = "";
  let border = "none";
  let color = "#fff";

  switch (event.type) {
    case "shift":
      backgroundColor = "#4caf50"; // ✅ green for shift
      break;
    case "weekoff":
      backgroundColor = "#9e9e9e"; // ⚪ grey for week off
      break;
    case "no record":
      backgroundColor = "#f44336"; // ❌ red for no record
      break;
    default:
      backgroundColor = "#2196f3"; // 🔵 fallback
  }

  return {
    style: {
      backgroundColor,
      border,
      color,
      borderRadius: "6px",
      fontWeight: 600,
      padding: "20px",
      textAlign: "center",
      borderRadius:"13px 13px 0px 0px"
    },
  };
};

console.log(showPopup ,"showPopup defaultDate",defaultDate);
// const handleNavigate = (date, view, action) => {
//   // ❌ Block all navigation actions (NEXT, PREV, TODAY)
//   return defaultDate; 
// };

// const handleNavigate = (newDate, view, action) => {
//   const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month);
//   const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

//   const targetMonth = newDate.getMonth()+1;
//   const targetYear = newDate.getFullYear();

//   // If user tries to go OUTSIDE allowed month → block
//   if (targetMonth !== allowedMonth || targetYear !== allowedYear) {
//     return; // ❌ Reject navigation
//   }

//   // ✔ Accept the navigation
// };

// const handleNavigate = (newDate, view, action) => {
//   // block month jumping
//   const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month);
//   const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

//   const m = newDate.getMonth() + 1;
//   const y = newDate.getFullYear();

//   if (m !== allowedMonth || y !== allowedYear) return;
// };

// const handleNavigate = (newDate, view, action) => {
//   const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month); // 1–12
//   const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

//   const targetMonth = newDate.getMonth() + 1;
//   const targetYear = newDate.getFullYear();

//   // 1️⃣ BLOCK MONTH VIEW navigation fully
//   if (view === "month") {
//     return; // ❌ navigation rejected
//   }

//   console.log(targetMonth ,"sufposdf targetMonth",allowedMonth ,allowedYear, 

//     targetMonth !== allowedMonth || targetYear !== allowedYear
//   );
  
//   // 2️⃣ WEEK / WORK_WEEK / DAY → must remain inside allowed month+year
//   if (targetMonth !== allowedMonth || targetYear !== allowedYear) {
//     // ❌ Reject navigation
//     // OPTIONAL: show toast or Swal error here
//     // Swal.fire("Cannot go outside allowed month!");
//     return;
//   }

//   // 3️⃣ If inside month, allow navigation (Calendar will update automatically)
//   // Nothing to do here.
// };

// const handleNavigate = (newDate, view, action) => {
//   const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month); // 1-12
//   const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

//   const targetMonth = newDate.getMonth() + 1;
//   const targetYear = newDate.getFullYear();

//   const isAllowed = targetMonth === allowedMonth && targetYear === allowedYear;

//   console.log("targetMonth", targetMonth, targetYear, isAllowed);

//   if (!isAllowed) {
//     // ❌ Block navigation
//     // REVERT back to existing date
//     setCurrentDate(currentDate);
//     return;
//   }

//   // ✔ Allow
//   setCurrentDate(newDate);
// }; // working 

// const handleNavigate = (newDate, view, action) => {
//   const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month); // 1–12
//   const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

//   const targetMonth = newDate.getMonth() + 1;
//   const targetYear = newDate.getFullYear();

//   const isAllowed = targetMonth === allowedMonth && targetYear === allowedYear;

//   console.log("Navigate:", view, action, "newDate=", newDate);

//   // ---- AGENDA VIEW ----
//   if (view === "agenda") {
//     // ALWAYS force start-of-month
//     const forcedAgendaDate = new Date(allowedYear, allowedMonth - 1, 1);
//     setCurrentDate(forcedAgendaDate);
//     return;
//   }

//   // ---- MONTH VIEW BLOCKED ----
//   if (view === "month") {
//     setCurrentDate(currentDate);
//     return;
//   }

//   // ---- WEEK / DAY VIEW: must remain inside allowed month ----
//   if (!isAllowed) {
//     setCurrentDate(currentDate);
//     return;
//   }

//   // ---- ALLOW VALID NAVIGATION ----
//   setCurrentDate(newDate);
// };

// const handleNavigate = (newDate, view, action) => {
//   const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month); // 1–12
//   const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

//   console.log("Navigate:", view, action, newDate);

//   const dateObj = new Date(newDate);
//   const targetMonth = dateObj.getMonth() + 1;
//   const targetYear = dateObj.getFullYear();

//   // Helper: Is this date inside allowed month?
//   const isInside = (date) => {
//     return (
//       date.getMonth() + 1 === allowedMonth &&
//       date.getFullYear() === allowedYear
//     );
//   };

//   // 1️⃣ AGENDA → always reset to start of month
//   if (view === "agenda") {
//     setCurrentDate(new Date(allowedYear, allowedMonth - 1, 1));
//     return;
//   }

//   // 2️⃣ MONTH VIEW → fully blocked
//   if (view === "month") {
//     setCurrentDate(currentDate);
//     return;
//   }

//   // 3️⃣ DAY VIEW → block if outside month
//   if (view === "day") {
//     if (!isInside(dateObj)) {
//       setCurrentDate(currentDate);
//       return;
//     }
//     setCurrentDate(dateObj);
//     return;
//   }

//   // 4️⃣ WEEK VIEW → check entire week boundaries
//   if (view === "week") {
//     const startOfWeek = new Date(dateObj);
//     startOfWeek.setDate(dateObj.getDate() - dateObj.getDay()); // Sunday

//     const endOfWeek = new Date(startOfWeek);
//     endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday

//     // ❌ If ANY day in week is outside allowed month → block
//     if (!isInside(startOfWeek) || !isInside(endOfWeek)) {
//       setCurrentDate(currentDate);
//       return;
//     }

//     setCurrentDate(dateObj);
//     return;
//   }

//   // 5️⃣ WORK_WEEK → check Mon–Fri
//   if (view === "work_week") {
//     const monday = new Date(dateObj);
//     monday.setDate(dateObj.getDate() - ((dateObj.getDay() + 6) % 7)); // Monday

//     const friday = new Date(monday);
//     friday.setDate(monday.getDate() + 4); // Friday

//     // ❌ If Mon or Fri is outside allowed month → block
//     if (!isInside(monday) || !isInside(friday)) {
//       setCurrentDate(currentDate);
//       return;
//     }

//     setCurrentDate(dateObj);
//     return;
//   }
// };


const handleNavigate = (newDate, view, action) => {
  const allowedMonth = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.month); // 1–12
  const allowedYear = Number(state.ShifteexcelshettRetriev?.ShfiexcelRetrieve?.year);

  const current = new Date(newDate);

  const isInside = (date) => {
    return (
      date.getMonth() + 1 === allowedMonth &&
      date.getFullYear() === allowedYear
    );
  };

  // 1️⃣ AGENDA → always force to 1st of month
  if (view === "agenda") {
    setCurrentDate(new Date(allowedYear, allowedMonth - 1, 1));
    return;
  }

  // 2️⃣ MONTH view → completely blocked
  if (view === "month") {
    setCurrentDate(currentDate);
    return;
  }

  // 3️⃣ DAY view → must remain inside month
  if (view === "day") {
    if (!isInside(current)) {
      setCurrentDate(currentDate);
      return;
    }
    setCurrentDate(current);
    return;
  }

  // 4️⃣ WEEK view → block week if ANY day is outside allowed month
if (view === "week") {
  // find start of week (Sunday)
  const start = new Date(current);
  start.setDate(current.getDate() - current.getDay());

  // find end of week (Saturday)
  const end = new Date(start);
  end.setDate(start.getDate() + 6);

  // CHECK: Does at least 1 day belong to allowed month?
  let hasAllowedDay = false;

  for (let i = 0; i < 7; i++) {
    const day = new Date(start);
    day.setDate(start.getDate() + i);

    if (isInside(day)) {
      hasAllowedDay = true;
      break;
    }
  }

  console.log("WEEK CHECK:", start, end, "hasAllowedMonth:", hasAllowedDay);

  // ❌ Block if NO day belongs to allowed month
  if (!hasAllowedDay) {
    console.log("BLOCKED WEEK: no days in allowed month");
    setCurrentDate(currentDate);
    return;
  }

  // ✔ Show week if ANY day is inside month
  setCurrentDate(current);
  return;
}


  // 5️⃣ WORK_WEEK → block if Monday or Friday outside month
  if (view === "work_week") {
    const monday = new Date(current);
    monday.setDate(current.getDate() - ((current.getDay() + 6) % 7));

    const friday = new Date(monday);
    friday.setDate(monday.getDate() + 4);

    if (!isInside(monday) || !isInside(friday)) {
      console.log("BLOCKED WORK_WEEK");
      setCurrentDate(currentDate);
      return;
    }

    setCurrentDate(current);
    return;
  }
};




// const CustomToolbar = (toolbar) => {
//   const date = toolbar.date;
//   const month = date.toLocaleString("en-US", { month: "long" });
//   const year = date.getFullYear();
//   return (
//     <div className="rbc-toolbar">
//       <span className="rbc-toolbar-label">
//         {month} {year}
//       </span>
//     </div>
//   );
// };
// const CustomToolbar = (toolbar) => {
//   const date = toolbar.date;
//   const month = date.toLocaleString("en-US", { month: "long" });
//   const year = date.getFullYear();

//   return (
//     <div className="rbc-toolbar">

//       {/* Left Buttons (Back, Today, Next) */}
//       <span className="rbc-btn-group">

//         {/* BACK button – disable navigation */}
//         <button
//           type="button"
//           onClick={() => {}}
//         >
//           ‹
//         </button>

//         {/* TODAY button – also disabled navigation */}
//         <button
//           type="button"
//           onClick={() => {}}
//         >
//           Today
//         </button>

//         {/* NEXT button – disable navigation */}
//         <button
//           type="button"
//           onClick={() => {}}
//         >
//           ›
//         </button>
//       </span>

//       {/* LABEL */}
//       <span className="rbc-toolbar-label">
//         {month} {year}
//       </span>

//       {/* Right Buttons (Month, Week, Day, Agenda) */}
//       <span className="rbc-btn-group">
//         <button type="button" onClick={() => toolbar.onView("month")}>
//           Month
//         </button>
//         <button type="button" onClick={() => toolbar.onView("work_week")}>
//           Week
//         </button>
//         <button type="button" onClick={() => toolbar.onView("day")}>
//           Day
//         </button>
//         <button type="button" onClick={() => toolbar.onView("agenda")}>
//           Agenda
//         </button>
//       </span>
//     </div>
//   );
// };
// const CustomToolbar = (toolbar) => {
//   const date = toolbar.date;
//   const view = toolbar.view;

//   const month = date.toLocaleString("en-US", { month: "long" });
//   const year = date.getFullYear();

//   const addDays = (base, days) => {
//     const d = new Date(base);
//     d.setDate(d.getDate() + days);
//     return d;
//   };

//   const handleNavigate_inner = (action) => {
//     // MONTH VIEW → do not move
//     if (view === "month") return;

//     // WEEK VIEW (7-day week)
//     if (view === "week") {
//       const newDate = addDays(
//         date,
//         action === "NEXT" ? 7 : action === "PREV" ? -7 : 0
//       );
//       toolbar.onNavigate(action, newDate);
//       return;
//     }

//     // DAY VIEW → move 1 day
//     if (view === "day") {
//       const newDate = addDays(
//         date,
//         action === "NEXT" ? 1 : action === "PREV" ? -1 : 0
//       );
//       toolbar.onNavigate(action, newDate);
//       return;
//     }
//   };

//   return (
//     <div className="rbc-toolbar">
//       {/* Navigation buttons */}
//       <span className="rbc-btn-group">
//         <button type="button" onClick={() => handleNavigate_inner("PREV")}>‹</button>
//         <button type="button" onClick={() => handleNavigate_inner("TODAY")}>Today</button>
//         <button type="button" onClick={() => handleNavigate_inner("NEXT")}>›</button>
//       </span>

//       {/* Center Label */}
//       <span className="rbc-toolbar-label">
//         {month} {year}
//       </span>

//       {/* View mode buttons */}
//       <span className="rbc-btn-group">
//         <button type="button" onClick={() => toolbar.onView("month")}>Month</button>
//         <button type="button" onClick={() => toolbar.onView("week")}>Week</button>
//         <button type="button" onClick={() => toolbar.onView("day")}>Day</button>
//         <button type="button" onClick={() => toolbar.onView("agenda")}>Agenda</button>
//       </span>
//     </div>
//   );
// };




const CustomToolbar = (toolbar) => {
  const date = toolbar.date;
  const view = toolbar.view;

  const defaultMonth = new Date(defaultDate).getMonth();
  const defaultYear = new Date(defaultDate).getFullYear();

  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  const addDays = (base, days) => {
    const d = new Date(base);
    d.setDate(d.getDate() + days);
    return d;
  };

  const isWithinDefaultMonth = (newDate) => {
    return (
      newDate.getMonth() === defaultMonth &&
      newDate.getFullYear() === defaultYear
    );
  };

  const handleNavigate_inner = (action) => {
    let newDate = null;

    // Block month view entirely
    if (view === "month") return;

    if (view === "week") {
      newDate = addDays(date, action === "NEXT" ? 7 : action === "PREV" ? -7 : 0);

      // ❌ BLOCK if new week goes out of default month
      if (!isWithinDefaultMonth(newDate)) return;

      toolbar.onNavigate(action, newDate);
      return;
    }

    if (view === "day") {
      newDate = addDays(date, action === "NEXT" ? 1 : action === "PREV" ? -1 : 0);

      // ❌ BLOCK if new day goes out of default month
      if (!isWithinDefaultMonth(newDate)) return;

      toolbar.onNavigate(action, newDate);
      return;
    }
  };

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        {/* <button type="button" onClick={() => handleNavigate_inner("PREV")}>‹</button>
        <button type="button" onClick={() => handleNavigate_inner("TODAY")}>Today</button>
        <button type="button" onClick={() => handleNavigate_inner("NEXT")}>›</button> */}
      </span>

      <span className="rbc-toolbar-label">
        {month} {year}
      </span>

      <span className="rbc-btn-group">
        <button type="button" onClick={() => toolbar.onView("month")}>Month</button>
        {/* <button type="button" onClick={() => toolbar.onView("week")}>Week</button> */}
        {/* <button type="button" onClick={() => toolbar.onView("day")}>Day</button> */}
        <button type="button" onClick={() => toolbar.onView("agenda")}>Agenda</button>
      </span>
    </div>
  );
};




  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="row" style={{ padding: "15px", marginRight: "0px" }}>
          <div className="col-6 ">
            <button
              class="btn  Buttons"
              onClick={(e) => {
                navigate("/clientDetails");
              }}
            >
              Back 
            </button>
          </div>
        </div>

        <div className="row" style={{ padding: "15px", marginRight: "0px" }}>
          <div className="col-6">
            {Name != undefined ? <h4>{Name}</h4> : null}
          </div>
          <div className="col-6" style={{ textAlign: "end" }}>
            {udsID != undefined ? <h4>{udsID}</h4> : null}
          </div>
        </div>

<div className="Calendar" style={{  maxHeight: "100vh", padding:"0px 11px" }}>
  <Calendar
    key={defaultDate?.toISOString()} // ✅ Forces re-render when defaultDate changes
    localizer={localizer}
  views={["month", "week", "day", "agenda"]}
    selectable
    defaultDate={defaultDate} // ✅ now dynamically aligned
    defaultView="month"
    events={events}
    date={currentDate}
  // date={defaultDate}           // 👈 Force calendar to stay on this month
    style={{ height: "595px" }} // Adjust for header/footer if needed
    eventPropGetter={eventPropGetter}
    onSelectSlot={handleDateClick}
    onSelectEvent={handleDateClick}
    onNavigate={handleNavigate}  // 👈 Block navigation
  // components={{
  //   toolbar: CustomToolbar,    // 👈 Remove back/next buttons
  // }}

  />
</div>

      {showPopup && (
        <ConfirmationPopup
          selectedDate={selectedDate}
          onClose={() => setShowPopup(false)}
        />
      )}
      </div>
    </>
  );
};

export default Calender;
